// Valeurs d'orientation — miroir de ValeurOrientation côté API (non exposées
// par constants/BOA : l'API ne renvoie pas le référentiel des codes). Le code
// d'une organisation est l'une de ces valeurs. L'alias FT (rangé sous PE par
// l'API) n'est pas proposé. Si l'API ajoute une valeur, cette liste doit suivre.
export const VALEURS_ORIENTATION = [
  { id: "CAF", name: "CAF" },
  { id: "CAF_EG", name: "CAF EG" },
  { id: "PE", name: "France Travail" },
  { id: "CD", name: "Conseil départemental" },
  { id: "ML", name: "Mission locale" },
  { id: "ML_NORD", name: "Mission locale Nord" },
  { id: "ML_SUD", name: "Mission locale Sud" },
  { id: "ML_EST", name: "Mission locale Est" },
  { id: "ML_OUEST", name: "Mission locale Ouest" },
];

export const libelleValeurOrientation = (code) =>
  VALEURS_ORIENTATION.find((v) => v.id === code)?.name ?? code ?? "";

/** Les valeurs qu'une nouvelle organisation peut encore porter : toutes, moins celles des organisations existantes. */
export const codesOrientationDisponibles = (organisations = []) => {
  const pris = new Set(organisations.map((o) => (o.slugName ?? "").toString().trim().toUpperCase()));
  return VALEURS_ORIENTATION.filter((v) => !pris.has(v.id));
};
